var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.4335C15.8222 20.4335 15.6556 20.4058 15.5 20.3502C15.3444 20.2946 15.2 20.2002 15.0667 20.0669L8.93333 13.9335C8.68889 13.6891 8.56667 13.378 8.56667 13.0002C8.56667 12.6224 8.68889 12.3113 8.93333 12.0669C9.17778 11.8224 9.48889 11.7002 9.86667 11.7002C10.2444 11.7002 10.5556 11.8224 10.8 12.0669L16 17.2669L21.2 12.0669C21.4444 11.8224 21.7556 11.7002 22.1333 11.7002C22.5111 11.7002 22.8222 11.8224 23.0667 12.0669C23.3111 12.3113 23.4333 12.6224 23.4333 13.0002C23.4333 13.378 23.3111 13.6891 23.0667 13.9335L16.9333 20.0669C16.8 20.2002 16.6556 20.2946 16.5 20.3502C16.3444 20.4058 16.1778 20.4335 16 20.4335Z",
    fill: "#0E88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMoreIcon);
export default __webpack_public_path__ + "static/media/expand-more-icon.e4acf936b3d9a4825ee8d83ddaaa47a0.svg";
export { ForwardRef as ReactComponent };